// extracted by mini-css-extract-plugin
export default {"modal":"eOc4HS8xlqyuJYHldM1P__modal___","modalDescription":"s2LmWUB9YlhNfDNiARDy__modalDescription___"};